import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Settings } from 'lucide-react';
import { Button } from '@/components/ui/button';

interface UserActionsProps {
  scrolled: boolean;
  isMobile?: boolean;
}

const UserActions: React.FC<UserActionsProps> = ({ scrolled, isMobile = false }) => {
  if (isMobile) {
    return (
      <>
        <a 
          href="https://saas.afsprakenmaker.be" 
          target="_blank"
          rel="noopener noreferrer"
          className="px-4 py-3 text-sm font-medium text-gray-700"
        >
          Login
        </a>
        <Button asChild className="mt-2 bg-brand-red hover:bg-brand-red/90">
          <Link to="/contact" className="flex items-center justify-center">
            <Mail className="mr-2 h-4 w-4" />
            <span>Contacteer ons</span>
          </Link>
        </Button>
      </>
    );
  }
  
  return (
    <div className="flex items-center space-x-2">
      {/* Contact Button */}
      <Button asChild className={`hidden md:flex items-center bg-brand-red hover:bg-brand-red/90 transition-all duration-300 ${
        scrolled ? 'px-3 py-1 h-8' : 'px-4 py-2'
      }`}>
        <Link to="/contact" title="Contacteer ons" className="flex items-center">
          <Mail className={`h-4 w-4 ${scrolled ? 'inline-block' : 'hidden'} transition-all duration-300`} />
          <span className={`${scrolled ? 'hidden' : 'inline-block'} transition-all duration-300`}>Contacteer ons</span>
        </Link>
      </Button>
      
      {/* Login Button - External redirect to SaaS platform */}
      <Button asChild className={`hidden md:flex transition-all duration-300 ${
        scrolled ? 'px-3 py-1 h-8' : ''
      }`} variant="outline">
        <a 
          href="https://saas.afsprakenmaker.be" 
          target="_blank" 
          rel="noopener noreferrer" 
          title="Login" 
          className="flex items-center"
        >
          <Settings className={`h-4 w-4 ${scrolled ? 'inline-block' : 'mr-2'} transition-all duration-300`} />
          <span className={`${scrolled ? 'hidden' : 'inline-block'} transition-all duration-300`}>
            Login
          </span>
        </a>
      </Button>
    </div>
  );
};

export default UserActions;
